import React, { useState } from 'react'
import { Layout, Menu, Drawer, Button } from 'antd'
import { MenuOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import './Header.scss'

const { Header: AntHeader } = Layout

const Header = () => {
  // 移动端抽屉菜单状态
  const [drawerOpen, setDrawerOpen] = useState(false)

  // 菜单数据（匹配设计稿：Home/About us/Contact us）
  const menuItems = [
    { key: 'home', name: 'Home', label: <Link to='/'>Home</Link> },
    { key: 'about', name: 'About us', label: <Link to='/about'>About us</Link> },
    { key: 'contact', name: 'Contact us', label: <Link to='/contact'>Contact us</Link> }
  ]

  return (
    <AntHeader className='header-container'>
      <div className='header-inner'>
        {/* 企业Logo */}
        <div className='logo'>
          <span>L AND P</span>
        </div>

        {/* 桌面端菜单 */}
        <Menu mode='horizontal' items={menuItems} className='header-menu desktop-menu' />

        {/* 移动端菜单按钮 + 抽屉 */}
        <Button icon={<MenuOutlined />} onClick={() => setDrawerOpen(true)} className='mobile-menu-btn' />
        <Drawer
          title='Menu'
          placement='right'
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          className='mobile-drawer'
        >
          <Menu mode='vertical' items={menuItems} className='mobile-menu' onClick={() => setDrawerOpen(false)} />
        </Drawer>
      </div>
    </AntHeader>
  )
}

export default Header
